export default "__VITE_ASSET__BDCUXEfw__"